export default __webpack_public_path__ + "static/media/order2.08c902e0.svg";